import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "completedForms";

const loadFromLocalStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const saveToLocalStorage = (forms) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(forms));
};

const initialState = {
  completedForms: loadFromLocalStorage(),
};

const formsSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    addForm: (state, action) => {
      state.completedForms.push(action.payload);
      saveToLocalStorage(state.completedForms);
    },
    deleteForm: (state, action) => {
      state.completedForms = state.completedForms.filter(
        (f) => f.id !== action.payload
      );
      saveToLocalStorage(state.completedForms);
    },
    clearAllForms: (state) => {
      state.completedForms = [];
      saveToLocalStorage([]);
    },
  },
});

export const { addForm, deleteForm, clearAllForms } = formsSlice.actions;
export default formsSlice.reducer;
